import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Sep 19 2026 — the old hard `window.location.href` redirect on ANY 401 (including silent
// background polling) was kicking reps/managers back to the default tab mid-session and wiping
// whatever they were typing. That behavior is now permanently banned: a plain expired/invalid
// session NEVER auto-navigates. It shows one dismissible toast with a manual "Log In Again"
// button — the rep keeps working, their scroll position/open tab/typed note never move — and
// only navigates if/when they click it themselves. Deduped so it only shows once per expiry.
let sessionExpiredNotified = false;
export function resetSessionExpiredFlag() {
  sessionExpiredNotified = false;
}

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = error.config?.url || "";
    if (error.response?.status === 401 && !url.includes("/auth/login") && !url.includes("/auth/me") && window.location.pathname !== "/login") {
      if (error.response?.data?.detail === "FORCE_LOGOUT") {
        // An admin explicitly ended this session right now — this one stays immediate/intentional.
        toast.error("An admin has ended your session. Please log back in.", { duration: 6000 });
        setTimeout(() => { window.location.href = "/login"; }, 1200);
      } else if (!sessionExpiredNotified) {
        sessionExpiredNotified = true;
        toast.error("Your session has expired. Your work here is safe — nothing on this screen will change. Log back in whenever you're ready.", {
          duration: Infinity,
          action: { label: "Log In Again", onClick: () => { window.location.href = "/login"; } },
        });
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
